export enum DMN_SIT_PLANO {
  ATIVO = 1,
  DESLIGADO = 2,
  AUTOPATROCINIO = 3,
  ASSISTIDO = 4,
  EM_LICENCA = 5,
  NAO_DEFINIDO = 6,
  DIFERIDO = 7,
}